module.exports = __webpack_public_path__ + "static/slider-01-94b7a4a7b0595a108b048a2bd356b909.jpg";